import {generateManifestText} from './generateManifestText';
import {SCRIPT_HEADER_NOTICES} from './scriptHeaderNotices';
import {CompatibleScriptableManifest} from './types';

/**
 * Generates a Scriptable banner with manifest settings
 * @param manifest Optional manifest settings to include in the banner
 * @param noDefaults If true, omits default values from the banner
 * @returns Generated banner string with manifest settings
 */
export function generateScriptableBanner(manifest?: CompatibleScriptableManifest, noDefaults = false): string {
  return (
    [...SCRIPT_HEADER_NOTICES, generateManifestText(manifest, noDefaults)].map(line => `// ${line}`).join('\n') + '\n'
  );
}
